"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExposureEvent = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _universalAnalytics = require("@zillow/universal-analytics");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExposureEvent = function ExposureEvent(exposureEventPayload) {
  (0, _universalAnalytics.event)(exposureEventPayload, {
    integrations: {
      gtm: false
    }
  });
};

exports.ExposureEvent = ExposureEvent;
ExposureEvent.propTypes = {
  // eslint-disable-next-line zillow/react/forbid-prop-types
  exposureEventPayload: _propTypes.default.object
};
ExposureEvent.defaultProps = {
  exposureEventPayload: {}
};